module.exports = __webpack_public_path__ + "img/step2-c.e0ac50d2.png";